// extracted by mini-css-extract-plugin
module.exports = {"header":"A7ap"};